import Parser from "../../rz-status_parser";
import { useTimer } from "../contextProviders/TimerContext";
import { useCollapse } from "../contextProviders/CollapseContext";
import useData from "../useData";
import Constants from "../../rz-status_constants";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import Markdown from "react-markdown";
import { IExternalIncident } from "../../rz-status_models";
import EventCounter from "./eventCounter";

export default function()  {
	const { expanded, toggle} = useCollapse();
    const tick = useTimer();

	const parser = new Parser();
  	const { data, error, loading } = useData(Constants.Paths.externalIncidentsJsonPath, (file) => parser.parseExternalIncidents(file), [tick]);

	return <article className={"externalIncidents collapsible"+ ((expanded == 3) ? " open" : "")} id="externalIncidents">
			<header>
				<h2>
					<button className="incidentTitle" aria-expanded={(expanded == 3) ? "true" : "false"} aria-controls="externalIncidentsCollapsible" aria-label="" onClick={() => toggle(3)} aria-label={`Weitere Störungen außerhalb DATEV ${(expanded == 3) ? "schließen" : "öffnen"}`}>
						<span className="h2">Weitere Störungen außerhalb DATEV</span>
						<div>
							<EventCounter id="externalIncidentsNumber" countable={data ?? []}/>
							<span className="arrow"></span>
						</div>
					</button>
				</h2>
			</header>
			<div id="externalIncidentsCollapsible" className="collapsible-content">
				<section className="textbox external">
					<article id="externalIncidentsDetails">
						
						{data == null || data.length == 0
						?  <section className="banner incidentinfo clearfix info">
								<article>
									<header>
										<p>Aktuell liegen keine Informationen über Störungen außerhalb DATEV vor.</p>
									</header>
								</article>
							</section>
						: <> {data.map(i => <Incident key={i.id} incident={i}/>)}</>
						}                 
						
					</article>
					<article className="furtherInfo">                                   
						<p>
							<a href="https://www.elster.de/elsterweb/svs" title="Elster" target="_blank">Störungen bei der Verfügbarkeit der ELSTER-Server</a>  
						</p>
					</article>
					<article className="furtherInfo">
						<p> 
							Informieren Sie sich bei Verbindungsproblemen auch im Internet über Störungen bei den Netzprovidern 
						</p>
						<p>
							<a href="https://www.heise.de/netze/netzwerk-tools/imonitor-internet-stoerungen/" title="iMonitor" target="_blank">iMonitor - Internetstörungen</a> auf <a href="https://www.heise.de/" title="Heise Online" target="_blank">www.heise.de</a>
						</p>
					</article>
					<article className="furtherInfo">
						<a href="https://www.bzst.de/" target="_blank">Bundeszentralamt für Steuern</a>
					</article>
				</section>
			</div>
		</article>
}

function Incident({incident} : {incident: IExternalIncident}) {
    return <section className="banner incidentinfo clearfix warning">
        <article>
            <header>
                <p>{incident.title}</p>
            </header>
            <section className="commonmark">
				<Markdown remarkPlugins={[remarkBreaks,remarkGfm]}>{incident.markdown}</Markdown>
            </section>
        </article>
	</section>
}